/* eslint-disable @typescript-eslint/no-explicit-any */
import { Action, combineReducers, ThunkDispatch } from '@reduxjs/toolkit';
import { hydrateReducer } from './utils/hydrateReducer';
import {
  precounselingInitialState,
  precounselingReducer,
} from './features/precounseling';
import {
  queryParamsInitialState,
  queryParamsReducer,
} from './features/queryParams';
import {
  jobTrendRankingInitialState,
  jobTrendRankingReducer,
} from './features/JobContent/JobTrend/jobTrendRanking';
import { analyticsInitialState, analyticsReducer } from './features/analytics';
import {
  jobRecommendOffsetReducer,
  jobRecommendOffsetInitialState,
} from './features/JobContent/JobTrend/jobRecommendOffset';
import {
  jobRecommendListForTrendIncomeInitialState,
  jobRecommendListForTrendIncomeReducer,
} from './features/JobContent/JobTrend/jobRecommendListForTrendIncome';
import {
  jobRecommendListForTrendEstablishInitialState,
  jobRecommendListForTrendEstablishReducer,
} from './features/JobContent/JobTrend/jobRecommendListForTrendEstablish';
import {
  jobRecommendListForTrendEmploymentStatusReducer,
  jobRecommendListForTrendEmploymentStatusState,
} from './features/JobContent/JobTrend/jobRecommendListForTrendEmploymentStatus';
import {
  jobRecommendListForTrendEmployeeAverageAgeInitialState,
  jobRecommendListForTrendEmployeeAverageAgeReducer,
} from './features/JobContent/JobTrend/jobRecommendListForTrendEmployeeAverageAge';
import {
  jobRecommendListForTrendLanguageAndPositionsInitialState,
  jobRecommendListForTrendLanguageAndPositionsReducer,
} from './features/JobContent/JobTrend/jobRecommendListForTrendLanguageAndPositions';
import {
  jobRecommendListForTrendWelfareBenefitsInitialState,
  jobRecommendListForTrendWelfareBenefitsReducer,
} from './features/JobContent/JobTrend/jobRecommendListForTrendWelfareBenefits';
import {
  jobRecommendListForTrendHolidayAndWayOfWorkingInitialState,
  jobRecommendListForTrendHolidayAndWayOfWorkingReducer,
} from './features/JobContent/JobTrend/jobRecommendListForTrendHolidayAndWayOfWorking';
import {
  jobRecommendListForTrendWorkplaceEnvironmentInitialState,
  jobRecommendListForTrendWorkplaceEnvironmentsReducer,
} from './features/JobContent/JobTrend/jobRecommendListForTrendWorkplaceEnvironment1';
import {
  jobRecommendListForTrendRequirementsInitialState,
  jobRecommendListForTrendRequirementsReducer,
} from './features/JobContent/JobTrend/jobRecommendListForTrendRequirements';
import { seoTextInitialState, seoTextReducer } from './features/seoText';
import { canonicalInitialState, canonicalReducer } from './features/canonical';
import {
  prefOnlySelectInitialState,
  prefOnlySelectReducer,
} from './features/prefOnlyFlgSlice';
import { abTestInitialState, abTestReducer } from './features/abTest';
import {
  intentionJobListInitialState,
  intentionJobListReducer,
} from './features/intentionJobList';
import {
  jobContentLinkInitialState,
  jobContentLinkReducer,
} from './features/JobContent/jobContentLink';
import {
  jobTrendRecommendListInitialState,
  jobTrendRecommendListReducer,
} from './features/JobContent/JobTrend/jobTrendRecommendList';
import { jobCountInitialState, jobCountReducer } from './features/jobCount';
import { masterInitialState, masterReducer } from './features/master';
import {
  memberInfoInitialState,
  memberInfoReducer,
} from './features/memberInfo';
import {
  plpLinkListDataIndexReducer,
  seoPlpLinkListDataIndexInitialState,
} from './features/plpLinkList';
import {
  bookmarkReducer,
  bookmarkSliceInitialState,
} from './features/referredJobDetail/slices/bookmark';
import {
  searchLabelInitialState,
  searchLabelReducer,
} from './features/searchConditionLabel';
import {
  featureFlagInitialState,
  featureFlagReducer,
} from './features/featureFlag';

// NOTE: この reducer は common 配下存在する slice をまとめたものである
// common 配下のモジュールは sp・pc 両方から使われることを想定しているので、この slice は必ず sp・pc 両方の store に存在しないといけないため、export して sp・pc で使う
// ただ、common は状態を持たないのが理想なので、common 配下で新しく slice や状態のやりとりは増やさないようにする

export const commonReducer = {
  abTest: abTestReducer,
  analytics: analyticsReducer,
  canonical: canonicalReducer,
  intentionJobList: intentionJobListReducer,
  jobContentLink: jobContentLinkReducer,
  jobTrendRanking: jobTrendRankingReducer,
  jobRecommendOffset: jobRecommendOffsetReducer,
  jobRecommendListForTrendIncome: jobRecommendListForTrendIncomeReducer,
  jobRecommendListForTrendEstablish: jobRecommendListForTrendEstablishReducer,
  jobRecommendListForTrendEmploymentStatus:
    jobRecommendListForTrendEmploymentStatusReducer,
  jobRecommendListForTrendEmployeeAverageAge:
    jobRecommendListForTrendEmployeeAverageAgeReducer,
  jobRecommendListForTrendLanguageAndPositions:
    jobRecommendListForTrendLanguageAndPositionsReducer,
  jobRecommendListForTrendWelfareBenefits:
    jobRecommendListForTrendWelfareBenefitsReducer,
  jobRecommendListForTrendHolidayAndWayOfWorking:
    jobRecommendListForTrendHolidayAndWayOfWorkingReducer,
  jobRecommendListForTrendWorkplaceEnvironment:
    jobRecommendListForTrendWorkplaceEnvironmentsReducer,
  jobRecommendListForTrendRequirements:
    jobRecommendListForTrendRequirementsReducer,
  jobTrendRecommendList: jobTrendRecommendListReducer,
  jobCount: jobCountReducer,
  master: masterReducer,
  memberInfo: memberInfoReducer,
  plpLinkList: plpLinkListDataIndexReducer,
  precounseling: precounselingReducer,
  prefOnlyFlg: prefOnlySelectReducer,
  queryParams: queryParamsReducer,
  bookmark: bookmarkReducer,
  searchLabel: searchLabelReducer,
  seoText: seoTextReducer,
  featureFlag: featureFlagReducer,
};

export const commonInitialState = {
  abTest: abTestInitialState,
  analytics: analyticsInitialState,
  canonical: canonicalInitialState,
  intentionJobList: intentionJobListInitialState,
  jobContentLink: jobContentLinkInitialState,
  jobTrendRanking: jobTrendRankingInitialState,
  jobRecommendOffset: jobRecommendOffsetInitialState,
  jobRecommendListForTrendIncome: jobRecommendListForTrendIncomeInitialState,
  jobRecommendListForTrendEstablish:
    jobRecommendListForTrendEstablishInitialState,
  jobRecommendListForTrendEmploymentStatus:
    jobRecommendListForTrendEmploymentStatusState,
  jobRecommendListForTrendEmployeeAverageAge:
    jobRecommendListForTrendEmployeeAverageAgeInitialState,
  jobRecommendListForTrendLanguageAndPositions:
    jobRecommendListForTrendLanguageAndPositionsInitialState,
  jobRecommendListForTrendWelfareBenefits:
    jobRecommendListForTrendWelfareBenefitsInitialState,
  jobRecommendListForTrendHolidayAndWayOfWorking:
    jobRecommendListForTrendHolidayAndWayOfWorkingInitialState,
  jobRecommendListForTrendWorkplaceEnvironment:
    jobRecommendListForTrendWorkplaceEnvironmentInitialState,
  jobRecommendListForTrendRequirements:
    jobRecommendListForTrendRequirementsInitialState,
  jobTrendRecommendList: jobTrendRecommendListInitialState,
  jobCount: jobCountInitialState,
  master: masterInitialState,
  memberInfo: memberInfoInitialState,
  plpLinkList: seoPlpLinkListDataIndexInitialState,
  precounseling: precounselingInitialState,
  prefOnlyFlg: prefOnlySelectInitialState,
  queryParams: queryParamsInitialState,
  bookmark: bookmarkSliceInitialState,
  searchLabel: searchLabelInitialState,
  seoText: seoTextInitialState,
  featureFlag: featureFlagInitialState,
};

export const reducer = hydrateReducer(
  combineReducers(commonReducer),
  commonInitialState
);

export type RootState = ReturnType<typeof reducer>;

// Dispatch型 宣言
export type AppDispatch = ThunkDispatch<RootState, unknown, Action>;
